export default {
  data() {
    return {
      toast_delay: parseInt(process.env.VUE_APP_TOAST_DELAY, 10),
      icons: {
        // TODO: sort keys in alphabetical order except for deposit and loan icons
        account: "papsi_account_green.svg",
        account_disabled: "papsi_account_disabled.svg",
        add: "papsi_add.svg",
        asterisk: "papsi_asterisk.svg",
        back: "papsi_back_grey.svg",
        back_white: "papsi_back_white.svg",
        backspace: "papsi_backspace.svg",
        birthday: "papsi_birthday.svg",
        dropdown: "papsi_dropdown_grey.svg",
        box: "papsi_box.svg",
        edit: "papsi_edit.svg",
        edit_white: "papsi_edit_white.svg",
        enter: "papsi_enter.svg",
        exit: "papsi_exit_red.svg",
        "exit-modal": "papsi_exit_grey.svg",
        "exit-black": "papsi_exit_black.svg",
        group: "papsi_group_green.svg",
        hide: "papsi_hide.svg",
        show: "papsi_show.svg",
        check: "papsi_check_green.svg",
        first_page: "papsi_first.svg",
        last_page: "papsi_last.svg",
        first_page_disabled: "papsi_first_disabled.svg",
        last_page_disabled: "papsi_last_disabled.svg",
        forward_grey: "papsi_forward_grey.svg",
        help: "papsi_help.svg",
        id_card: "papsi_id.svg",
        info: "papsi_info_green.svg",
        pin: "papsi_pin.svg",
        "info-blue": "papsi_info_blue.svg",
        loans: "papsi_loan.svg",
        logout: "papsi_logout.svg",
        mail: "papsi_mail.svg",
        money_bag: "papsi_money_bag.svg",
        money_bag_green: "papsi_money_bag_green.svg",
        "next-green": "papsi_next_green.svg",
        "next-grey": "papsi_next_grey.svg",
        passbook: "papsi_passbook.svg",
        password_invisible: "papsi_password_invisible.svg",
        password_visible: "papsi_password_visible.svg",
        peso: "papsi_peso_green.svg",
        placeholder: "papsi_placeholder.svg",
        "prev-green": "papsi_prev_green.svg",
        prev_disabled: "papsi_prev_disabled.svg",
        "qr-green": "papsi_qr_green.svg",
        qr: "papsi_qr.svg",
        savings: "papsi_savings.svg",
        share_capital: "papsi_share_capital.svg",
        smartphone: "papsi_smartphone.svg",
        smartphone_green: "papsi_smartphone_green.svg",
        summary: "papsi_summary.svg",
        ticket: "papsi_ticket.svg",
        ticket_grey: "papsi_ticket_grey.svg",
        "user-card": "papsi_user.svg",
        user: "papsi_mobile_green.svg",
        RSD: "papsi_petty_cash.svg", // regular savings deposit
        SAV: "papsi_petty_cash.svg", // regular savings deposit
        SSD: "papsi_money_bag_green.svg", // special savings deposit
        D14: "papsi_appliance.svg", // appliance loan
        D44: "papsi_back_to_back.svg", // back-to-back loan
        D30: "papsi_business.svg", // business loan
        D09: "papsi_calamity.svg", // calamity loan
        D53: "papsi_car.svg", // car loan
        D07: "papsi_emergency.svg", // emergency loan
        D19: "papsi_housing.svg", // housing loan
        D52: "papsi_multipurpose.svg", // multi-purpose loan
        D36: "papsi_petty_cash.svg", // petty cash loan
        D54: "papsi_providential.svg", // providential loan
        D06: "papsi_salary.svg", // salary loan
        D18: "papsi_education.svg", // education loan
      },
      images: {
        kalabaw: "images/elements/papsi_kalabaw.png",
        logo: "images/elements/papsi_logo.png",
        "pia-1": "images/elements/pia-logo-1.png",
        "pia-2": "images/elements/pia-logo-2.png",
        "pia-3": "images/elements/pia-logo-3.png",
        "pia-4": "images/elements/pia-logo-4.png",
        mascot: "images/elements/papsi_mascot.png",
        contact: "images/elements/papsi_contact.png",
        kara: "images/elements/papsi-kara.png",
        rate: "images/elements/papsi_rating.png",
        star: "images/elements/papsi_star.png",
        english: "images/elements/papsi_english.png",
        tagalog: "images/elements/papsi_tagalog.png",
        "edit-pin": "images/elements/papsi_edit_pin.png",
        santahat: "images/themes/papsi_santahat.png",
        garland: "images/themes/papsi_garland.png",
        "gift-1": "images/themes/papsi_gifts.png",
        "gift-2": "images/themes/papsi_gifts2.png",
        "cloud-1": "images/themes/papsi_cloud1.png",
        "cloud-2": "images/themes/papsi_cloud2.png",
        love: "images/themes/papsi_love.png",
        hearteyes: "images/themes/papsi_hearteyes.png",
        lunar: "images/themes/papsi_lunar.png",
        "dragon-1": "images/themes/papsi_dragon.png",
        "dragon-2": "images/themes/papsi_dragon2.png",
        chinese: "images/themes/papsi_chinese.png",
        fan: "images/themes/papsi_fan.png",
        sparkle: "images/themes/papsi_sparkle.png",
        privacy_seal: "images/elements/papsi_npc_seal_of_registration.png",
        sun: "images/themes/papsi_sun.png",
        "flag-corner": "images/themes/papsi_flag.png",
        "flag-1": "images/themes/papsi_left.png",
        "flag-2": "images/themes/papsi_right.png",
        "hween-1": "images/themes/hween-1.png",
        "hween-2": "images/themes/hween-2.png",
        ghost: "images/themes/ghosts.png",
      },
    };
  },

  methods: {
    getIcon(id) {
      if (!this.icons[id]) {
        if (id != "") {
          console.error(`Icon: "${id}" does not exist.`);
        }
        return require("@/assets/icons/papsi_password_visible.svg"); // TODO: replace with default icon
      }
      return require(`@/assets/icons/${this.icons[id]}`);
    },
    getImage(id) {
      if (!this.images[id]) {
        if (id != "") {
          console.error(`Image: "${id}" does not exist.`);
        }
        return `${process.env.VUE_APP_MEDIA_URL}/papsi_kalabaw.png`;
      }
      return `${process.env.VUE_APP_MEDIA_URL}/${this.images[id]}`;
    },
    getMediaPath(path) {
      return process.env.VUE_APP_MEDIA_URL + "images" + path;
    },
    toggleExistingSessionModal() {
      this.existing_session = !this.existing_session;
    },
    forceLogout() {
      this.$store.commit("setLanguage", "en"); // Reset the language to English
      this.$i18n.locale = "en"; // Ensure i18n is updated immediately
      this.$router.push({
        name: "start-page",
        query: { device_id: this.$store.state.branch.device_id },
      });
      this.existing_session = false;
    },
    goBack() {
      this.$router.back();
    },
    refresh() {
      window.location.reload();
    },
    toggleModal() {
      this.is_modal_open = !this.is_modal_open;
    },
    toggleRating() {
      this.is_rating_open = !this.is_rating_open;
    },
    handleRedirect(redirect_to) {
      if (redirect_to) {
        this.$router.push(redirect_to);
      }
    },
    makeHashCookie(hash) {
      if (!this.$cookies.isKey("hash")) {
        this.$cookies.set("hash", hash);
      }
    },
    saveUserData(data) {
      const user_state = this.$store.state.user;
      const balances = data.balances;

      user_state.is_logged_in = true;
      user_state.uuid = data.uuid;
      user_state.hash = data.hash;
      user_state.key = data.key;
      user_state.qr = data.qr;
      user_state.balance_ref = data.balance_ref;
      user_state.pso_enroll = data.pso_enroll;
      user_state.pin_update = data.pin_update;
      this.makeHashCookie(user_state.hash);

      user_state.first_name = data.info.first_name;
      user_state.middle_name = data.info.middle_name;
      user_state.last_name = data.info.last_name;
      user_state.account_number = data.info.account_number;
      user_state.serial_number = data.info.serial_number;
      user_state.membership_type = data.info.membership_type;
      user_state.mobile = data.info.mobile;
      user_state.email = data.info.email;
      user_state.tin = data.info.tin;
      user_state.birthdate = data.info.date_of_birth;

      Object.entries(balances).forEach(
        ([code, { total_balance, total_records, as_of }]) => {

          this.$store.commit("addBalance", {
            code: code,
            balance: total_balance,
            records: total_records,
            as_of: as_of,
          });
          console.log(code, as_of);
        },
      );
    },
    savePINEnrollee(data, input_value, input_type) {
      const enrollee_state = this.$store.state.pin_enrollment;

      enrollee_state.uuid = data.uuid;
      enrollee_state.hash = data.hash;
      enrollee_state.mobile = data.mobile;
      enrollee_state.email = data.email;
      enrollee_state.name = data.name;
      enrollee_state.account = input_value;
      enrollee_state.account_type = input_type;
    },
    clearUserCookie() {
      if (this.$cookies.isKey("hash")) {
        this.$cookies.remove("hash");
      }
      if (this.$cookies.isKey("has_rated")) {
        this.$cookies.remove("has_rated");
      }
    },
    clearBranchCookie() {
      if (this.$cookies.isKey("session_id")) {
        this.$cookies.remove("session_id");
      }
    },
    resetUserData() {
      const user_state = this.$store.state.user;
      user_state.old_pin = null;
      user_state.is_logged_in = false;
      user_state.uuid = null;
      user_state.hash = null;
      user_state.key = null;
      user_state.qr = null;
      user_state.first_name = null;
      user_state.middle_name = null;
      user_state.last_name = null;
      user_state.account_number = null;
      user_state.serial_number = null;
      user_state.membership_type = null;
      user_state.mobile = null;
      user_state.email = null;
      user_state.tin = null;
      user_state.birthday = null;
      user_state.ledgers = [];
      user_state.hasAgreedToPrivacyMobile = false;
      user_state.hasAgreedToPrivacyEmail = false;
      user_state.hasAgreedToPrivacyBirthday = false;
      user_state.hasAgreedToPrivacyTIN = false;
      user_state.hasAgreedToPrivacyPIN = false;
    },
    resetBranchData() {
      const branch_state = this.$store.state.branch;
      branch_state.branch_abbr = null;
      branch_state.branch_code = null;
      branch_state.branch_name = null;
      branch_state.kiosk_id = null;
      branch_state.session_id = null;
    },
    restoreBranchData() {
      const branch_state = this.$store.state.branch;
      branch_state.session_id = this.$cookies.get("session_id");
      branch_state.branch_abbr = this.$cookies.get("branch_abbr");
      branch_state.branch_code = this.$cookies.get("branch_code");
      branch_state.branch_name = this.$cookies.get("branch_name");
      branch_state.kiosk_id = this.$cookies.get("kiosk_id");
      // console.log("Refreshed branch state:", branch_state);
    },
    restoreUserData(data) {
      const user_state = this.$store.state.user;
      user_state.is_logged_in = true;
      user_state.uuid = data.uuid;
      user_state.hash = this.$cookies.get("hash");
      user_state.key = data.key;
      user_state.qr = data.qr;
      user_state.balance_ref = data.balance_ref;
      user_state.first_name = data.info.first_name;
      user_state.middle_name = data.info.middle_name;
      user_state.last_name = data.info.last_name;
      user_state.account_number = data.info.account_number;
      user_state.serial_number = data.info.serial_number;
      user_state.membership_type = data.info.membership_type;
      user_state.mobile = data.info.mobile;
      user_state.email = data.info.email;
      user_state.tin = data.info.tin;
      user_state.birthdate = data.info.date_of_birth;
      // console.log("Refreshed user state:", user_state);
    },
    showSuccess(message) {
      this.$toast.open({
        message: message,
        duration: this.toast_delay,
        type: "success",
        position: "top-right",
      });
    },
    showInfo(message) {
      this.$toast.open({
        message: message,
        duration: this.toast_delay,
        type: "info",
        position: "top-right",
      });
    },
    showError(message) {
      this.$toast.open({
        message: message,
        duration: this.toast_delay,
        type: "error",
        position: "top-right",
      });
    },
    formatAmount(amount) {
      const rounded_amount = parseFloat(amount).toFixed(2);
      const [integer, decimal] = rounded_amount.split(".");
      const formatted_integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return decimal ? `${formatted_integer}.${decimal}` : formatted_integer;
    },
    isDecimal(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    isDate(value) {
      const is_date = /^\d{4}-\d{2}-\d{2}$/.test(value);
      return is_date;
    },
    formatDate(input_date) {
      const date = new Date(input_date);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    },
    formatTime(input_time) {
      const [hour, minute, second] = input_time.split(":").map(Number);
      const period = hour < 12 ? "AM" : "PM";
      const formattedHour = hour % 12 || 12;
      return `${formattedHour}:${minute.toString().padStart(2, "0")}:${second
        .toString()
        .padStart(2, "0")} ${period}`;
    },
  },
};
